import moment from 'moment';
import {
  join
} from '../Array.lib';
import {
  DATE_FORMAT__DATE__ISO,
  TIMEZONE__LA
} from '../Date.lib';
import {
  trim
} from '../String.lib';

/**
 * Prepends a private note to a candidate's existing notes with a timestamp.
 *
 * @async
 * @function prependPrivateNote
 * @param {Object} params - Function parameters.
 * @param {Object} [params.candidate={}] - Candidate object containing `privateNotes`.
 * @param {string} [params.note=''] - The note text to prepend.
 * @returns {Promise<string>} Updated private notes with the new note prepended.
 *
 * @description
 * - Trims the incoming note.
 * - If empty, returns existing notes unchanged.
 * - Prepends the note with current timestamp in Los Angeles timezone (ISO date format).
 * - Joins the new note and existing notes with a newline character.
 */
export default async function prependPrivateNote({
  candidate = {},
  note = ''
}) {
  note = trim(note);
  const existing = trim(candidate.privateNotes);
  if (!note) { return existing; }
  note = `${moment().tz(TIMEZONE__LA).format(DATE_FORMAT__DATE__ISO)}: ${note}`;
  return candidate.privateNotes = join([note, existing], '\n');
}
